import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ContentCopyOutlined from "@mui/icons-material/ContentCopyOutlined";
import CheckOutlined from "@mui/icons-material/CheckOutlined";

const COPY_FEEDBACK_MS = 2000;

const ReviewerUrlCopyButton = ({ url = "" }) => {
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    setIsCopied(false);
  }, [url]);

  if (!url?.trim()) {
    return null;
  }

  const onCopyUrl = async () => {
    if (!navigator?.clipboard?.writeText) {
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setIsCopied(true);
      window.setTimeout(() => setIsCopied(false), COPY_FEEDBACK_MS);
    } catch {
      // ignore clipboard errors
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        minWidth: 0,
        width: "100%",
      }}
    >
      <Typography
        variant="caption"
        sx={{
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontFamily: "monospace",
          color: "text.secondary",
          fontSize: "0.7rem",
        }}
      >
        {url}
      </Typography>
      <IconButton
        type="button"
        size="small"
        onClick={onCopyUrl}
        aria-label={isCopied ? "copied" : "copy"}
        sx={{ flexShrink: 0 }}
      >
        {isCopied ? (
          <CheckOutlined sx={{ fontSize: 14 }} />
        ) : (
          <ContentCopyOutlined sx={{ fontSize: 14 }} />
        )}
      </IconButton>
    </Box>
  );
};

export default ReviewerUrlCopyButton;
